/**
 * @generated SignedSource<<33b9ce41575cda088833d0bf3171d83c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NOT_COMPLETED_STARTED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
import { FragmentRefs } from "relay-runtime";
export type WidgetRoutineOverviewDataComponent_widgetRoutineOverview$data = {
  readonly id: string;
  readonly routines: ReadonlyArray<{
    readonly id: string;
    readonly inProgressOccasion: {
      readonly expireAt: string;
      readonly startAt: string;
      readonly status: RoutineOccasionStatus;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutineOverviewListItem_routineOccasion">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutineOverviewListItem_routine">;
  }>;
  readonly title: string;
  readonly " $fragmentType": "WidgetRoutineOverviewDataComponent_widgetRoutineOverview";
};
export type WidgetRoutineOverviewDataComponent_widgetRoutineOverview$key = {
  readonly " $data"?: WidgetRoutineOverviewDataComponent_widgetRoutineOverview$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutineOverviewDataComponent_widgetRoutineOverview">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetRoutineOverviewDataComponent_widgetRoutineOverview",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Routine",
      "kind": "LinkedField",
      "name": "routines",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetRoutineOverviewListItem_routine"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineOccasion",
          "kind": "LinkedField",
          "name": "inProgressOccasion",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expireAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "calculateNoTasks",
                  "value": true
                },
                {
                  "kind": "Literal",
                  "name": "calculateNotCompletedStarted",
                  "value": true
                }
              ],
              "kind": "ScalarField",
              "name": "status",
              "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetRoutineOverviewListItem_routineOccasion"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetRoutineOverview",
  "abstractKey": null
};
})();

(node as any).hash = "141b3059ba8d1698560dcaf9f0f4a6b0";

export default node;
